export default __webpack_public_path__ + "static/media/bengals_graph_learn.409b0745.png";